import React, { useState, useEffect, useContext, cloneElement, ReactElement } from 'react';
import {Grid, GridColumn as Column, GridDataStateChangeEvent, GridSortChangeEvent, GridCustomCellProps, GridToolbar, GridCellProps} from '@progress/kendo-react-grid';
import { GridColumnMenuFilter, GridColumnMenuProps } from '@progress/kendo-react-grid';
import { CompositeFilterDescriptor, filterBy, FilterDescriptor, orderBy, SortDescriptor } from '@progress/kendo-data-query';
import { Button, ToolbarItem } from '@progress/kendo-react-buttons';
import { PageContext } from './PageContext';
import { getAdHistory, getTrafficCCSubStatusList, getTrafficStatusList, getTrafficUserList,getTrafficNotes, saveTrafficNote,updateTraffic} from '../services/apiService';
import { subElement, trafficNote } from '../services/interfaces';
import { gSettings } from './Configuration';
import { filterIcon } from '@progress/kendo-svg-icons';

import { process, State, DataResult } from '@progress/kendo-data-query';

import { UserContext } from './UserContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faEnvelope, faAddressCard, faInfoCircle, faQuestionCircle} from '@fortawesome/free-solid-svg-icons';
import { getter } from '@progress/kendo-react-common';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import parse from 'html-react-parser';
import { DropDownList, DropDownListChangeEvent, DropDownListFilterChangeEvent, ListItemProps } from '@progress/kendo-react-dropdowns';
import { DateTimePicker } from '@progress/kendo-react-dateinputs';
import { Notification, NotificationGroup } from '@progress/kendo-react-notification';
import { Fade } from '@progress/kendo-react-animation';
import { longDateTime } from '../services/interfaces';
import { Editor, EditorChangeEvent, EditorTools, EditorMountEvent} from '@progress/kendo-react-editor'
import { useThemeSwitcher } from 'react-css-theme-switcher';


interface trafficUser{
    username:string,
    fullname:string
}
interface trafficStatus{
    status:string,
    color:string,
    displayOrder:number
}


const initialDataState: State = {
    sort: [{ field: 'time', dir: 'desc' }],
};




const ColumnMenu = (props: GridColumnMenuProps) => {
    return (
        <div>
            <GridColumnMenuFilter {...props} expanded={true} />
        </div>
    );
};

export function TrafficPanel (){
    const [notes, setNotes] = useState<Array<subElement>>([]);
    
    const pageContext=useContext(PageContext);
    const userContext=useContext(UserContext);
    const [dataState, setDataState]=useState<State>(initialDataState);
    const [dataResult, setDataResult]=useState<DataResult>(process(notes,dataState));
    const [trafficUsers, setTrafficUsers] = useState<trafficUser[]>([]);
    const [trafficStatus,setTrafficStatus]=useState<trafficStatus[]>([]);
    const [trafficCCSubStatus,setTrafficCCSubStatus]=useState<trafficStatus[]>([]);
    const [trafficAssignedTo, setTrafficAssignedTo]=useState<trafficUser>({fullname:"", username:""});
    const [trafficSelStatus,setTrafficSelStatus]=useState<trafficStatus>({status:"",color:"",displayOrder:0});
    const [trafficSelCCSubStatus,setTrafficSelCCSubStatus]=useState<trafficStatus>({status:"",color:"",displayOrder:0});
    const [noteVisible,setNoteVisible]=useState(false);
    const [locale, setLocale] = useState<string | undefined>(undefined);
    const [newNoteText,setNewNoteText]=useState("");
    const { switcher, themes, currentTheme, status } = useThemeSwitcher();
    const [maxChars,setMaxChars]=useState(false);

    const getNotes=()=>{
        const element = pageContext?.selectedAd.element;
        if (element){
            getTrafficNotes(element).then(data=>{
                console.log(data);
                setNotes(data);
                setDataResult(process(data, dataState));
            });
        }
    }

const filterAssignCC=(e:DropDownListFilterChangeEvent)=>{
    getTrafficUserList().then(data=>{
        if (data){
            const filteredData:trafficUser[] = filterBy(data,e.filter)    
            setTrafficUsers(filteredData);

        }
    })
}   

const filterAssignStatus=(e:DropDownListFilterChangeEvent)=>{
    getTrafficStatusList().then(data=>{
        if (data){
            const filteredData:trafficStatus[] = filterBy(data,e.filter)    
            setTrafficStatus(filteredData);

        }
    })
}   

const filterAssignSubStatus=(e:DropDownListFilterChangeEvent)=>{
    getTrafficCCSubStatusList().then(data=>{
        if (data){
            const filteredStatusData:trafficStatus[] = filterBy(data,e.filter)    
            setTrafficCCSubStatus(filteredStatusData);
        }
    })
}   



const trafficAssignCC=(event:DropDownListChangeEvent)=>{
    var selected=event.value;
    console.log(selected);
    var assignedTo=selected.username;
    var element = pageContext?.selectedAd.element;
    if (element && assignedTo){
        updateTraffic(element,"assignedTo",assignedTo).then(()=>{
                setTrafficAssignedTo(selected);
                pageContext?.setSelectedAd(prevObject=>({...prevObject,assignedTo:assignedTo,assignedFullName:selected.fullName}));
                getNotes();
        })
    }

}

const trafficSetStatus=(event:DropDownListChangeEvent)=>{
    var selected=event.value;
    console.log(selected);
    var status=selected.status;
    var element = pageContext?.selectedAd.element;
    if (element && status){
        updateTraffic(element,"status",status).then(()=>{
                setTrafficSelStatus(selected);
                pageContext?.setSelectedAd(prevObject=>({...prevObject,trafficStatus:status}));
                getNotes();
        })
    }

}

const trafficSetCCSubStatus=(event:DropDownListChangeEvent)=>{
    var selected=event.value;
    console.log(selected);
    var status=selected.status;
    var element = pageContext?.selectedAd.element;
    if (element && status){
        updateTraffic(element,"ccStatus",status).then(()=>{
                setTrafficSelCCSubStatus(selected);
                pageContext?.setSelectedAd(prevObject=>({...prevObject,ccSubStatus:status}));
                getNotes();
        })
    }

}

    const showNewNote=()=>{
        setNoteVisible(true);
    }

    const noteTextChange=(event: EditorChangeEvent)=>{
        if (newNoteText.length<3096){
            setNewNoteText(event.html);
        }else{
            setMaxChars(true);
        }
    }
    const saveNote=()=>{
        console.log(newNoteText);
        
        const newNote:trafficNote ={
            element:pageContext?.selectedAd.element ?? "",
            username:userContext?.user.username ?? "",
            note:newNoteText,
            time:new Date().toISOString(),
            editby:userContext?.user.username ?? "",
            edittime:new Date().toISOString()
        }
        console.log(newNote);
        saveTrafficNote(newNote).then(data=>{
            hideNewNote();
            getNotes();
        });
    }

    const hideNewNote=()=>{
        setNoteVisible(false);
    }

    const fillTrafficUsers=(()=>{
        getTrafficUserList().then(data=>{
            setTrafficUsers(data);
        })
    });

    const fillTrafficStatus=()=>{
        getTrafficStatusList().then(data=>{
            setTrafficStatus(data);
        })
    }

    const fillTrafficCCSubStatus=()=>{
        getTrafficCCSubStatusList().then(data=>{
            setTrafficCCSubStatus(data);
        })
    }

    const trafficUserItem=(li: ReactElement<HTMLLIElement>, itemProps:ListItemProps)=>{
        const itemChildren=(
            <span>
                {itemProps.dataItem.fullname} ({itemProps.dataItem.username})
            </span>
        )
        return cloneElement(li,li.props,itemChildren);
    }


    const onDataStateChange = (e: GridDataStateChangeEvent) => {
            setDataState(e.dataState);
            setDataResult(process(notes, e.dataState));
        };
    
    const localeDate=(props:GridCustomCellProps)=>{
        console.log(props.dataItem);
        const newDateTime=new Date(props.dataItem.time);
         return (
             <td {...props.tdProps}>
                {newDateTime.toLocaleDateString(locale) + " " + newDateTime.toLocaleTimeString(locale)}
             </td>
         )
    }

    const styles = currentTheme === "dark"
        ? `
            p {
                font-family: Arial, sans-serif;
                color: #ffffff;
            }
        `
        :
        `
            p {
                font-family: Arial, sans-serif;
                color: #000000;
            }
        ` ;

    const onMount = (event: EditorMountEvent) => {
        const iframeDocument = event.dom.ownerDocument;
        const style = iframeDocument.createElement('style');
        style.appendChild(iframeDocument.createTextNode(styles));
        iframeDocument.head.appendChild(style);
    };

    const formatCell=(e:GridCellProps)=>{
        return (
            <td>
                <span dangerouslySetInnerHTML={{ __html: e.dataItem.note }} />
            </td>
        );
    }

    useEffect(() => {
        getNotes()
        fillTrafficUsers();
        fillTrafficStatus();
        fillTrafficCCSubStatus();

        gSettings().then(settings => setLocale(settings.Locale));        
    }, []);

    useEffect(()=>{
        if (pageContext?.selectedAd.assignedTo!=""){
            const assignedTo=pageContext?.selectedAd.assignedTo;
            //console.log(assignedTo);
            trafficUsers.map((user: trafficUser) => {
                if (user.username === assignedTo) {
                    setTrafficAssignedTo(user);
                }
            });
        }
    },[trafficUsers])

    useEffect(()=>{
        if (pageContext?.selectedAd.assignedTo!=""){
            const tstat=pageContext?.selectedAd.trafficStatus;
            //console.log(assignedTo);
            trafficStatus.map((status: trafficStatus) => {
                if (status.status === tstat) {
                    setTrafficSelStatus(status);
                }
            });
        }
    },[trafficStatus])

     useEffect(()=>{
        if (pageContext?.selectedAd.ccSubStatus!=""){
            const tstat=pageContext?.selectedAd.ccSubStatus;
            //console.log(assignedTo);
            trafficCCSubStatus.map((status: trafficStatus) => {
                if (status.status === tstat) {
                    setTrafficSelCCSubStatus(status);
                }
            });
        }
    },[trafficCCSubStatus])

    const {Bold,Italic,Underline,OrderedList,UnorderedList}=EditorTools;

    return(
        <>
        {noteVisible?
        //Assign CS Dialog
        <Dialog title={"New Traffic Note"} width={"25%"} onClose={hideNewNote}>
            {maxChars?
            <Notification type={{ style: 'warning', icon: true }}
                closable={true}
                onClose={() => setMaxChars(false)}
            >
            <span>Maximum characters is 3069</span>
            </Notification>
            :null}
            <Editor 
                tools={[[Bold,Italic]]} 
                style={{height:200}} 
                value={newNoteText} 
                onChange={noteTextChange} 
                data-bs-theme={currentTheme} 
                onMount={onMount}
            />
            <DialogActionsBar>
                <Button themeColor={"secondary"}onClick={hideNewNote}>Cancel</Button>
                <Button themeColor={"primary"} onClick={saveNote}>Save</Button>
            </DialogActionsBar>
        </Dialog>
        :null}
        <Grid
            data={dataResult}
            key="time"
            dataItemKey='element'
            scrollable='scrollable'
            sortable={true}
            onDataStateChange={onDataStateChange}
            columnMenuIcon={filterIcon}
            {...dataState}
        >
            <GridToolbar>
                <ToolbarItem>
                    <p>Assigned To:</p>
                    <DropDownList dataItemKey="username" textField="fullname" data={trafficUsers} itemRender={trafficUserItem} value={trafficAssignedTo} style={{marginRight:"10px"}} onChange={trafficAssignCC} filterable={true} onFilterChange={filterAssignCC}/>
                </ToolbarItem>
                <ToolbarItem>
                    <p>Traffic Status:</p>
                    <DropDownList dataItemKey="status" textField="status" data={trafficStatus} value={trafficSelStatus} style={{marginRight:"10px"}} onChange={trafficSetStatus} filterable={true} onFilterChange={filterAssignStatus}/>
                </ToolbarItem>
                <ToolbarItem>
                    <p>CC SubStatus:</p>
                    <DropDownList dataItemKey="status" textField="status" data={trafficCCSubStatus} value={trafficSelCCSubStatus} style={{marginRight:"10px"}} onChange={trafficSetCCSubStatus} filterable={true} onFilterChange={filterAssignSubStatus}/>
                </ToolbarItem>
                <ToolbarItem>
                    <p>&nbsp;</p>
                    <Button onClick={showNewNote}>Add Note</Button>
                </ToolbarItem>
                
            </GridToolbar>            
            <Column
                field="time"
                title="Time"
                cells={{data:localeDate}}
                width={200}
                columnMenu={ColumnMenu} 

            />
            <Column
                field='username'
                title='User'
                columnMenu={ColumnMenu} 
            />            
            <Column
                field='note'
                title='Note'
                columnMenu={ColumnMenu}
                cells={{data:formatCell}}
            />
        </Grid>
        </>
    )
}